<form [formGroup]="taskApiForm">
  <div class="filters-card k-card k-card-type-rich">
    <div class="k-card-body filters-section">
      <div class="form-group-inline">
        <label><strong>API *</strong></label>
        <kendo-combobox
          class="task-dropdown"
          [data]="listOfApis"
          formControlName="apiName"
          placeholder="Select API"
        ></kendo-combobox>

        <div class="sync-now-container">
          <div class="radio-group">
            <label class="section-label"><strong>Options</strong></label>

            <label class="radio-option">
              <input
                kendoRadioButton
                type="radio"
                value="All"
                formControlName="syncOption"
              />
              <span>All Restaurants</span>
            </label>

            <label class="radio-option">
              <input
                kendoRadioButton
                type="radio"
                value="Specific"
                formControlName="syncOption"
              />
              <span>Specific Restaurants</span>
            </label>

            <div
              *ngIf="taskApiForm.get('syncOption')?.value === 'Specific'"
              class="dropdown-section"
            >
              <kendo-multiselect
                class="custom-multiselect"
                [data]="restaurants.data"
                formControlName="restaurantNumbers"
                [filterable]="true"
                (filterChange)="updateRestaurantSearch($event)"
                placeholder="Start typing restaurant number..."
              ></kendo-multiselect>
            </div>

            <label class="radio-option">
              <input
                kendoRadioButton
                type="radio"
                value="ReportingUnit"
                formControlName="syncOption"
              />
              <span>Reporting Unit</span>
            </label>

            <div
              *ngIf="taskApiForm.get('syncOption')?.value === 'ReportingUnit'"
              class="dropdown-section"
            >
              <kendo-combobox
                class="task-dropdown"
                [data]="reportingUnits.data"
                formControlName="reportingUnit"
                textField="ruNm"
                valueField="ruNo"
                [filterable]="true"
                (filterChange)="updateReportingUnitSearch($event)"
                placeholder="Start typing reporting unit name..."
              ></kendo-combobox>
            </div>
          </div>
        </div>

        <div class="buttons-section">
          <kendo-badge-container>
            <button
              type="submit"
              kendoButton
              size="medium"
              fillMode="outline"
              [disabled]="taskApiForm.invalid"
              (click)="onClickInvokeApI()"
              themeColor="success"
            >
              InvokeAPI
            </button>
          </kendo-badge-container>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="tab-content-container">
  <div class="tab-box k-card k-card-type-rich">
    <app-data-grid
      size="small"
      [dataItems]="tasks"
      [columns]="columns"
      [state]="state"
      (dataStateChange)="onDataStateChanged($event)"
      [filterable]="'menu'"
    >
      <ng-template columnTemplate let-row="row" field="taskId">
        <a (click)="row._expanded = !row._expanded || false">
          {{
            row._expanded || row.taskId.length <= 12
              ? row.taskId
              : (row.taskId | slice: 0 : 12) + "..."
          }}
        </a>
      </ng-template>
      <ng-template columnTemplate let-row="row" field="details">
        <kendo-badge-container>
          <button
            kendoButton
            size="small"
            fillMode="outline"
            [disabled]="false"
            (click)="openTaskDetails(row.taskId)"
            themeColor="success"
          >
            Details
          </button>
        </kendo-badge-container>
      </ng-template>
    </app-data-grid>
  </div>
</div>

<kendo-dialog *ngIf="selectedTaskDetails" (close)="selectedTaskDetails = null">
  <kendo-dialog-titlebar>Task Details</kendo-dialog-titlebar>

  <div *ngIf="selectedTaskDetails">
    <p><strong>Status:</strong> {{ selectedTaskDetails.state }}</p>
    <p>
      <strong>Received:</strong>
      {{ selectedTaskDetails.received | unixDate }}
    </p>
    <p>
      <strong>Started:</strong>
      {{ selectedTaskDetails.started | unixDate }}
    </p>
    <p>
      <strong>Succeeded:</strong>
      {{ selectedTaskDetails.succeeded | unixDate }}
    </p>
    <p>
      <strong>Runtime:</strong>
      {{ selectedTaskDetails.runtime | number: "1.2-2" }} seconds
    </p>
  </div>
</kendo-dialog>
